import React from 'react';
import {
  Box,
  Column,
  FluidImage,
  GridContainer,
  Icon,
  List,
  ListItem,
  Row,
  Typography,
} from '@vp/swan';
import PropTypes from 'prop-types';
import { useTranslations } from '@vp/om-translations';

export const DocPreview = ({ previews, optionId, alt = '', vertical }) => {
  const [errorMessages] = useTranslations(['errorMessages']);

  if (!previews || previews.length === 0) {
    return (
      <Box py={9} textAlign="center">
        <Typography fontWeight="bold">
          {errorMessages.oopsSomethingWentWrong}
        </Typography>
        <Typography>{errorMessages.defaultErrorDetails}</Typography>
        <Icon iconType="image" size="48p" marginTop={4} alt="" />
      </Box>
    );
  }

  if (vertical) {
    return (
      <List skin="minimal" p={0}>
        {previews.map((surface, index) => (
          <ListItem key={`${optionId}-preview-${index}`}>
            <FluidImage src={surface.previewUrl} alt={alt} />
          </ListItem>
        ))}
      </List>
    );
  }

  const widthPerElement = previews.length === 1 ? 12 : 6;
  return (
    <GridContainer>
      <Row>
        <Column span={12}>
          <Row component="ul">
            {previews.map((surface, index) => (
              <Column component="li" key={index} span={widthPerElement}>
                <FluidImage src={surface.previewUrl} alt={alt} />
              </Column>
            ))}
          </Row>
        </Column>
      </Row>
    </GridContainer>
  );
};

export const MemoizedDocPreview = React.memo(DocPreview);

DocPreview.propTypes = {
  previews: PropTypes.array.isRequired,
  optionId: PropTypes.string.isRequired,
  alt: PropTypes.string,
  vertical: PropTypes.bool,
};
